<div id='content'>
  <dx-toolbar style='padding-left: 16px; padding-right: 16px;margin-bottom: 4px'>
    <dxi-item location="after">
      <dx-button
        text="Print Order Details"
        [disabled]="selectedOrderIds.length === 0"
        (click)="printOrderDetails()"
      ></dx-button>
    </dxi-item>
    <dxi-item location="after">
      <dx-button
        text="Print Label"
        [disabled]="selectedOrderIds.length === 0"
        (click)="printLabels()"
      ></dx-button>
    </dxi-item>
    <dxi-item location='after'>
      <dx-button
        text="Clean Excluded"
        [disabled]="excludedOrders.length === 0"
        (click)='cleanExcluded()'
      ></dx-button>
    </dxi-item>
    <dxi-item location='after'>
      <dx-button
        text="Exclude"
        [disabled]="selectedOrderIds.length === 0"
        (click)='excludeOrders()'
      ></dx-button>
    </dxi-item>
    <dxi-item location='after'>
      <dx-button
        icon='columnchooser'
        (click)='showColumnChooser()'
      ></dx-button>
    </dxi-item>
  </dx-toolbar>
  <dx-data-grid
    [dataSource]="DataSource"
    [showRowLines]='true'
    [showBorders]='true'
    [highlightChanges]='true'
    [allowColumnReordering]='true'
    [repaintChangesOnly]='true'
    [hoverStateEnabled]='true'
    height='40vh'
    style='min-width: 250px !important;'
    [allowColumnResizing]='true'
    [columnAutoWidth]='true'
    [wordWrapEnabled]='true'
    [noDataText]='"Search to display any result."'
    [filterSyncEnabled]='true'
    [(selectedRowKeys)]="selectedOrderIds"
    (onOptionChanged)="optionChanged($event)"
    (selectedRowKeysChange)="handleSelectionChange()">
    <dxo-scrolling mode='multiple' [rowRenderingMode]="'virtual'"></dxo-scrolling>
    <dxo-pager
      [visible]='true'
      [allowedPageSizes]='[50, 100, 500]'
      [showInfo]='true'
      [showNavigationButtons]='true'
      [showPageSizeSelector]='true'
    ></dxo-pager>
    <dxo-paging [pageSize]="50"></dxo-paging>
    <dxo-filter-row [showOperationChooser]='true' [visible]='true'></dxo-filter-row>
    <dxo-filter-panel [visible]='true'></dxo-filter-panel>
    <dxo-selection mode='multiple' showCheckBoxesMode='always' selectAllMode='page'></dxo-selection>
    <dxo-sorting mode='multiple'></dxo-sorting>
    <dxo-remote-operations [filtering]='true' [sorting]='true' [paging]='true'></dxo-remote-operations>
    <dxo-header-filter [visible]='true'></dxo-header-filter>

    <dxi-column dataField='code' caption='Order Id' [minWidth]='80' [allowHeaderFiltering]='false'
                dataType='string'></dxi-column>
    <dxi-column dataField='client' [allowFiltering]='true' dataType='string'
                [allowHeaderFiltering]="false"></dxi-column>
    <dxi-column cssClass='wrappedColumnClass' caption='Last name' dataField='patientLastName' [allowFiltering]="true"
                [allowHeaderFiltering]="false" [minWidth]='60'></dxi-column>
    <dxi-column cssClass='wrappedColumnClass' caption='First name' dataField='patientFirstName' [allowFiltering]="true"
                [allowHeaderFiltering]="false" [minWidth]='60'></dxi-column>
    <dxi-column caption='Birthdate' dataField='patientBirthDate' dataType='date' [selectedFilterOperation]='"between"'
                [allowHeaderFiltering]='false'></dxi-column>
    <dxi-column dataField='status' dataType='string' [allowFiltering]='false' [allowHeaderFiltering]='true'
                caption='Status' cellTemplate='statusCellTemplate'>
      <dxo-header-filter [dataSource]='statusHeaderFilter'></dxo-header-filter>
    </dxi-column>
    <div *dxTemplate="let order of 'statusCellTemplate'">
      <div fxLayout='row' fxLayoutAlign='center center' [innerHTML]='getStatus(order.data)'></div>
    </div>


    <dxi-column dataField='id' [visible]='false' [showInColumnChooser]='true' dataType='number' sortIndex='1'
                [allowHeaderFiltering]="false" [allowFiltering]="true"
                sortOrder='desc'></dxi-column>
    <dxi-column caption='Order Date' dataField='orderDate' dataType='date' [allowHeaderFiltering]='false'
                [allowFiltering]="true"
                [visible]="false" [showInColumnChooser]="true"
                [selectedFilterOperation]='"between"'></dxi-column>
    <dxi-column dataField='patientCode' [allowFiltering]='true' dataType='number' [showInColumnChooser]="true"
                [allowHeaderFiltering]="false"
                [visible]="false"></dxi-column>
    <dxi-column caption='Unit' dataField='unit' dataType='string' [allowHeaderFiltering]='false' [allowFiltering]="true"
                [selectedFilterOperation]="'contains'" [showInColumnChooser]='true' [visible]='false'></dxi-column>
    <dxi-column caption='Tests' dataField='tests' [allowFiltering]='false' dataType='string'
                [showInColumnChooser]="true" [allowHeaderFiltering]="false"
                [visible]="false">
    </dxi-column>

    <dxi-column cellTemplate='editCellTemplate'>
    </dxi-column>
    <div *dxTemplate="let order of 'editCellTemplate'">
      <dx-button (onClick)='previewClicked.emit(order.data.id)' icon='fas fa-eye' hint='Preview'></dx-button>
    </div>
  </dx-data-grid>
  <app-printer-dialog-multiple
    [isOrder]="true"
    [popupVisible]="printDialogVisible"
    [requisitionIds]="selectedOrderIds"
    (closeEvent)="printDialogVisible = false">
  </app-printer-dialog-multiple>
</div>
